import { render, staticRenderFns } from "./GuiJi.vue?vue&type=template&id=05e3b5d6&scoped=true&"
import script from "./GuiJi.vue?vue&type=script&lang=js&"
export * from "./GuiJi.vue?vue&type=script&lang=js&"
import style0 from "./GuiJi.vue?vue&type=style&index=0&id=05e3b5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e3b5d6",
  null
  
)

export default component.exports